import { createFileRoute, redirect } from '@tanstack/react-router'
import { TemplatesListPage } from '@/pages/Templates/TemplatesListPage'
import { useAuthStore } from '@/store/authStore'
import { canAccessRoute } from '@/lib/roles'

export const Route = createFileRoute('/_authenticated/templates')({
  component: TemplatesListPage,
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (!canAccessRoute(role, '/templates')) {
      throw redirect({ to: '/' })
    }
  },
})
